export const LocationType = {
  location: 'location',
  facility: 'facility',
}

export function getLocationDisplayName(location: TenantLocation) {
  return location.internalName ?? location.publicName ?? location.sourceName ?? location.sourceId
}
